import React from 'react'
import useSteps from '../utils/Steps'

export default function Orders() {
  useSteps()

  return <div>Orders</div>
}
